import React from "react";

import { BasicInfoPage } from "./BasicInfo";
import { Route, useRouteMatch, Switch, Redirect } from "react-router-dom";
import ActionItemsList from "./ActionItemsList";
import DiscoverabilityPage from "./Discoverability/DiscoverabilityPage";

const ActionItemsPage = () => {
  let { path } = useRouteMatch();
  return (
    <Switch>
      <Route
        path={`${path}/:actionItemId/basic-info`}
        component={BasicInfoPage}
      />
      <Route path={`${path}/basic-info`} component={BasicInfoPage} />
      <Route
        path={`${path}/:actionItemId/discoverability`}
        component={DiscoverabilityPage}
      />
      <Route default>
        <ActionItemsList />
      </Route>
      <Route path={`${path}/:actionItemId`} exact>
        <Redirect to={`${path}`} />
      </Route>
    </Switch>
  );
};

export default ActionItemsPage;
